import { render, staticRenderFns } from "./VwaSettings.vue?vue&type=template&id=11541650&scoped=true&"
import script from "./VwaSettings.vue?vue&type=script&lang=ts&"
export * from "./VwaSettings.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./VwaSettings.vue?vue&type=style&index=1&lang=css&"
import style2 from "./VwaSettings.vue?vue&type=style&index=2&id=11541650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11541650",
  null
  
)

export default component.exports